import { type FormEvent, useState } from 'react';

interface SearchPanelProps {
  onSearch: (query: string) => Promise<string | null>;
}

/** Suche nach ICAO-Hex, Callsign oder Registrierung (Erkennung übernimmt App). */
export default function SearchPanel({ onSearch }: SearchPanelProps) {
  const [query, setQuery] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!query.trim() || busy) return;
    setBusy(true);
    setError(null);
    const err = await onSearch(query.trim());
    setError(err);
    setBusy(false);
  }

  return (
    <div className="search-panel">
      <form onSubmit={submit}>
        <div className="search-field">
          <svg
            className="search-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="7" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            className="mono"
            type="search"
            placeholder="Hex · Callsign · Reg"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setError(null);
            }}
            spellCheck={false}
            autoCapitalize="characters"
            autoCorrect="off"
            aria-label="Flugzeug suchen"
          />
        </div>
        <button type="submit" disabled={busy || !query.trim()}>
          {busy ? '…' : 'Suchen'}
        </button>
      </form>
      {error && <p className="search-error">{error}</p>}
    </div>
  );
}
